import * as Toggle from '@radix-ui/react-toggle-group'
import { useGeckoPermissions } from 'features/permissions'
import React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  line-height: 1.25;
`

export const StyledToggleRoot = styled(Toggle.Root)`
  all: unset;
  display: inline-flex;
  background-color: ${({ theme }) => theme.forecast.background2};
  border-radius: 0.25rem;
`
export const StyledToggleItem = styled(Toggle.Item)`
  all: unset;
  color: ${({ theme }) => theme.forecast.text4};
  background-color: ${({ theme }) => theme.forecast.background3};
  height: 1.4rem;
  width: 4rem;
  padding: 0 0.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-size: 0.675rem;

  &:hover {
    font-weight: 800;
    color: ${({ theme }) => theme.forecast.text2} !important;
    background-color: ${({ theme }) => theme.forecast.background4};
    cursor: pointer;
  }

  &:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  &[data-state='on'] {
    color: ${({ theme }) => theme.forecast.text1} !important;
    background-color: ${({ theme }) => theme.forecast.background4} !important;
  }

  &:focus {
    background-color: ${({ theme }) => theme.forecast.background4} !important;
  }
`

/**
 *
 * @returns Toggle component to be used in the login dropdown for switching on Permission Debugging
 */
export const PermissionGateToggle: React.FC = () => {
  const { showPermissionGates, setShowPermissionGates } = useGeckoPermissions()

  const onToggleChange = () => setShowPermissionGates((prev) => !prev)

  return (
    <StyledContainer>
      <div>Permission Gates</div>
      <StyledToggleRoot
        type='single'
        value={showPermissionGates ? 'show' : 'hide'}
        aria-label='Permission Gates'
        onClick={(event) => event.stopPropagation()}
        onValueChange={onToggleChange}>
        <StyledToggleItem value={'hide'}>Hide</StyledToggleItem>
        <StyledToggleItem value={'show'}>Show</StyledToggleItem>
      </StyledToggleRoot>
    </StyledContainer>
  )
}
